:host {
    p {
        margin: 0;
    }

    .s {
        @include typo-ws-paragraph-s;
    }

    .s.bold {
        @include typo-ws-paragraph-s-bold;
    }

    .m {
        @include typo-ws-paragraph;
    }

    .m.bold {
        @include typo-ws-paragraph-bold;
    }

    .l {
        @include typo-ws-paragraph-l;
    }
}
